import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Wrench, Megaphone } from "lucide-react";

const PAGE_MAP = {
  "/books": "books",
  "/shop": "shop",
  "/saadhna": "saadhna",
  "/events": "events",
  "/about": "about",
  "/contact": "contact",
};

export default function SiteGate({ children }) {
  const [config, setConfig] = useState(null);
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/site-config");
        if (mounted) setConfig(data);
      } catch { if (mounted) setConfig({}); }
    };
    load();
    const iv = setInterval(load, 60000); // refresh every minute
    return () => { mounted = false; clearInterval(iv); };
  }, []);

  if (!config) return <>{children}</>;

  const isStaff = user && (user.role === "admin" || user.role === "trustee");

  if (config.maintenance_mode && !isStaff && location.pathname !== "/login") {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div className="mx-auto h-20 w-20 rounded-full bg-[#5C061C] grid place-items-center text-[#EAB308] mb-6">
          <Wrench className="h-9 w-9" />
        </div>
        <h1 className="font-serif text-4xl text-[#5C061C]">Under Maintenance</h1>
        <p className="mt-4 text-[#6E6259] leading-relaxed">
          {config.maintenance_message || "The Sanstha portal is temporarily under maintenance."}
        </p>
        <p className="mt-6 font-serif text-[#B45309] text-lg">ॐ शान्तिः शान्तिः शान्तिः</p>
      </div>
    );
  }

  const pageKey = PAGE_MAP[location.pathname];
  if (pageKey && config.page_toggles && config.page_toggles[pageKey] === false && !isStaff) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {config.announcement && (
        <div className="bg-[#5C061C] text-[#FAF7F2] py-2 px-4 text-center text-sm flex items-center justify-center gap-2" data-testid="site-announcement">
          <Megaphone className="h-4 w-4 shrink-0" />
          <span>{config.announcement}</span>
        </div>
      )}
      {children}
    </>
  );
}
